import { ReceiptCategory } from "@/modules/settings/receipt-categories/types"
import { Http } from "@/network/http"
import { Filters, NotificationEnum, StatusEnum } from "@/utils/constants"
import { notificationAction } from "@/utils/helpers"

export const API_PREFIX_PATH = "/receipt-categories"

export const fetchReceiptCategories = async (filters?: Filters) => {
  return await Http.get(`${API_PREFIX_PATH}`, { params: filters })
}

export const fetchReceiptCategory = async (id: string) => {
  return await Http.get(`${API_PREFIX_PATH}/${id}`)
}

export const createReceiptCategories = async (data?: ReceiptCategory) => {
  return await Http.post(`${API_PREFIX_PATH}`, data)
}

export const updateReceiptCategories = async (id: string, data?: ReceiptCategory) => {
  return await Http.put(`${API_PREFIX_PATH}/${id}`, data)
}

export const deleteReceiptCategories = async (data: ReceiptCategory) => {
  try {
    const updatedData = { ...data }
    if (!updatedData.id) return
    const response = await updateReceiptCategories(updatedData.id, { ...updatedData, status: StatusEnum.DELETED })
    if (response.statusCode === 200) {
      notificationAction(NotificationEnum.DELETED, NotificationEnum.SUCCESS)
    }
  } catch (error) {
    console.error("Addition failed:", error)
    notificationAction(`Lỗi ${error}`, NotificationEnum.ERROR)
  }
}
